var _defs, _rect, _line, _line2, _text, _text2, _line3, _text3, _polyline, _circle, _line4, _circle2, _line5, _circle3, _line6, _circle4, _line7, _circle5, _line8, _circle6, _line9, _circle7, _line10, _circle8, _line11, _circle9, _line12, _circle10, _line13, _text4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioCacheforge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 600,
    viewBox: "0 0 1200 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "ah",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#2c2416"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "aa",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#8b6f47"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "hatch",
    width: 14,
    height: 14,
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 14,
    stroke: "#8b6f47",
    strokeWidth: 5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 600,
    fill: "#ece3d2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 500,
    x2: 1090,
    y2: 500,
    stroke: "#2c2416",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 500,
    x2: 130,
    y2: 90,
    stroke: "#2c2416",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 100,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 32,
    fill: "#6b5d4f",
    textAnchor: "end",
    transform: "rotate(-90 110 100)"
  }, "hit rate")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 1090,
    y: 562,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 32,
    fill: "#6b5d4f",
    textAnchor: "end"
  }, "iteration")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 250,
    x2: 1090,
    y2: 250,
    stroke: "#6b5d4f",
    strokeWidth: 3,
    strokeDasharray: "16 12"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 230,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 34,
    fill: "#6b5d4f",
    textAnchor: "start"
  }, "baseline")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "210,440 306,405 402,420 498,350 594,318 690,330 786,262 882,232 978,210 1074,196",
    fill: "none",
    stroke: "#8b6f47",
    strokeWidth: 6,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 440,
    r: 11,
    fill: "#8b6f47"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 500,
    x2: 210,
    y2: 514,
    stroke: "#2c2416",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 405,
    r: 11,
    fill: "#8b6f47"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 306,
    y1: 500,
    x2: 306,
    y2: 514,
    stroke: "#2c2416",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 420,
    r: 11,
    fill: "#8b6f47"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 402,
    y1: 500,
    x2: 402,
    y2: 514,
    stroke: "#2c2416",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 350,
    r: 11,
    fill: "#8b6f47"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 498,
    y1: 500,
    x2: 498,
    y2: 514,
    stroke: "#2c2416",
    strokeWidth: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 594,
    cy: 318,
    r: 11,
    fill: "#8b6f47"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 594,
    y1: 500,
    x2: 594,
    y2: 514,
    stroke: "#2c2416",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 330,
    r: 11,
    fill: "#8b6f47"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 690,
    y1: 500,
    x2: 690,
    y2: 514,
    stroke: "#2c2416",
    strokeWidth: 3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 786,
    cy: 262,
    r: 11,
    fill: "#8b6f47"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 786,
    y1: 500,
    x2: 786,
    y2: 514,
    stroke: "#2c2416",
    strokeWidth: 3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 882,
    cy: 232,
    r: 11,
    fill: "#8b6f47"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 882,
    y1: 500,
    x2: 882,
    y2: 514,
    stroke: "#2c2416",
    strokeWidth: 3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 978,
    cy: 210,
    r: 11,
    fill: "#8b6f47"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 978,
    y1: 500,
    x2: 978,
    y2: 514,
    stroke: "#2c2416",
    strokeWidth: 3
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1074,
    cy: 196,
    r: 11,
    fill: "#8b6f47"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 1074,
    y1: 500,
    x2: 1074,
    y2: 514,
    stroke: "#2c2416",
    strokeWidth: 3
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 594,
    y: 420,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 36,
    fill: "#8b6f47",
    textAnchor: "middle"
  }, "LLM-written policy")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioCacheforge);
export default __webpack_public_path__ + "static/media/portfolio-cacheforge.02f80f367b87119bbc8a6c0d8c747726.svg";
export { ForwardRef as ReactComponent };